import React from "react";
import ScrollService from ".././../../utilities/ScrollService";
import "./Profile.css";
import Typical from "react-typical";

const Profile = () => {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
         
             <br>
             </br>
             <br>

             </br>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm  <span className="highlighted-text">Ashwani Kumar Jha</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1
               
              >
                {" "}
                <Typical
                  loop={Infinity}
                  steps={[
                    "Front-End Developer",
                    1000,
                    "Competitive Programmer",
                    1000,
                    "React Developer",
                    1000,
                   
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
            Passionate about crafting user-centric front-end experiences
            </span>
          </div>
          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {" "}
              Hire Me{" "}
            </button>
            <a href="https://drive.google.com/file/d/1D14jRF-04RQ19svILXWGIf5nkRxNKT3K/view?usp=sharing" download="ashwani_resume.pdf">
              <button className="btn highlighted-btn"> Get Resume </button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
};
export default Profile;
